import type { UIApiConfig, UserAPI } from '@sydle/ui-api';
import { getAPI } from '@sydle/ui-api';
import { getApp, getConfig } from '@sydle/ui-utils';
import type { EnvironmentKeys } from '../models/Window';
import { OneAPIHelper } from '../utils/api/one.api';

export class ENV {
  static getKey(key: EnvironmentKeys): string | any {
    return getConfig<UIApiConfig>('ui-api')?.[key];
  }

  static getToken(): string | undefined {
    const currentApplication = getApp()?.identifier;
    if (currentApplication === 'servicedesk-embedded-guest') {
      return ENV.getKey('SD_EMBEDDED_GUEST_TOKEN');
    }

    if (OneAPIHelper.isLoggedIn()) {
      return getAPI<UserAPI>('userAPI')?.getUser()?.accessToken.token;
    }

    return ENV.getKey('REQUEST_PARAMS')?.headers?.Authorization?.replace('Bearer ', '');
  }

  static getHeaders(): { [key: string]: any } {
    const headers = {
      'Content-Type': 'application/json',
      'X-Explorer-Account-Token': ENV.getKey('ORGANIZATION_IDENTIFIER'),
      Authorization: `Bearer ${this.getToken() ?? ''}`,
    };

    return headers;
  }
}
